export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  // Exact match
  if (current === url) {
    return true
  }

  // Check if the current path starts with the url, but with a slash boundary
  if (current.startsWith(url + '/')) {
    return true
  }

  return false
}

// Export a function to check for exact match only (for parent menu items)
export function checkIsActiveExact(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  return current === url
}
